import { h, ref } from 'vue';
import { RegisterOrderExcelInfo, RegisterOrderExcelInfos } from '@/coreDomainsModule/entities/InputOrderExcelInfo';
import { showInfoModal } from '@/corePagesModule/components/InfoModal/InfoModalManager';
import { createModalActionResult, ModalActionResult } from '@/corePagesModule/components/modal/modalActions';
import { i18n } from '@/i18n';
import OrderExcelInfoSelectModalContent from './OrderExcelInfoSelectModalContent.vue';

const t = i18n.t;

/**
 * 発注取込で使用する読み込み設定を選択するモーダルを開く
 * @param orderExcelInfos - 選択候補の発注取込設定一覧
 * @returns モーダル操作結果
 */
export const openOrderExcelInfoSelectModal = async (
  orderExcelInfos: RegisterOrderExcelInfos
): Promise<ModalActionResult<RegisterOrderExcelInfo>> => {
  if (orderExcelInfos.length === 1) {
    return createModalActionResult('confirm', orderExcelInfos[0]);
  }

  const selectedId = ref(orderExcelInfos[0]?.id ?? '');
  /**
   * 選択中の設定IDを更新する
   * @param value - 選択した設定ID
   */
  const updateSelectedId = (value: string) => {
    selectedId.value = value;
  };

  /**
   * モーダル本体を描画する
   * @returns モーダル本体VNode
   */
  const renderModalContent = () =>
    h(OrderExcelInfoSelectModalContent, {
      orderExcelInfos,
      selectedId: selectedId.value,
      'onUpdate:selectedId': updateSelectedId,
    });

  const result = await showInfoModal({
    modalTitle: t('発注取込設定の選択'),
    modalDescription: '',
    modalContent: renderModalContent,
    backButtonLabel: t('キャンセル'),
    nextButtonLabel: t('取り込む'),
    icon: 'info',
    enableOutsideClick: false,
    modalWidth: 560,
    testId: 'order-excel-info-select-modal',
  });

  if (!result) {
    return createModalActionResult('deny');
  }

  const selectedOrderExcelInfo = orderExcelInfos.find((orderExcelInfo) => orderExcelInfo.id === selectedId.value);
  return selectedOrderExcelInfo ? createModalActionResult('confirm', selectedOrderExcelInfo) : createModalActionResult('deny');
};
